"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var blockFormat_1 = require("../utils/blockFormat");
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var roosterjs_editor_dom_2 = require("roosterjs-editor-dom");
var BlockWrapper = '<blockquote style="margin-top:0;margin-bottom:0"></blockquote>';
/**
 * @internal
 */
function experimentSetIndentation(editor, indentation) {
    var handler = indentation == 0 /* Increase */ ? indent : outdent;
    blockFormat_1.default(editor, function (region, start, end) {
        var blocks = roosterjs_editor_dom_1.getSelectedBlockElementsInRegion(region);
        var blockGroups = [[]];
        for (var i = 0; i < blocks.length; i++) {
            var startNode = blocks[i].getStartNode();
            var vList = roosterjs_editor_dom_2.createVListFromRegion(region, true /*includeSiblingLists*/, startNode);
            if (vList) {
                blockGroups.push([]);
                while (blocks[i + 1] && vList.contains(blocks[i + 1].getStartNode())) {
                    i++;
                }
                vList.setIndentation(start, end, indentation);
                vList.writeBack();
            }
            else {
                blockGroups[blockGroups.length - 1].push(blocks[i]);
            }
        }
        blockGroups.forEach(function (group) { return handler(region, group); });
    });
}
exports.default = experimentSetIndentation;
function indent(region, blocks) {
    if (blocks.length > 0) {
        var startNode = blocks[0].getStartNode();
        var endNode = blocks[blocks.length - 1].getEndNode();
        var nodes = roosterjs_editor_dom_2.collapseNodesInRegion(region, [startNode, endNode]);
        roosterjs_editor_dom_2.wrap(nodes, BlockWrapper);
    }
}
function outdent(region, blocks) {
    blocks.forEach(function (blockElement) {
        var node = blockElement.collapseToSingleElement();
        var quote = roosterjs_editor_dom_2.findClosestElementAncestor(node, region.rootNode, 'blockquote');
        if (quote) {
            if (node == quote) {
                node = roosterjs_editor_dom_2.wrap(roosterjs_editor_dom_2.toArray(node.childNodes));
            }
            while (roosterjs_editor_dom_2.isNodeInRegion(region, node) && roosterjs_editor_dom_2.getTagOfNode(node) != 'BLOCKQUOTE') {
                node = roosterjs_editor_dom_2.splitBalancedNodeRange(node);
            }
            if (roosterjs_editor_dom_2.isNodeInRegion(region, node)) {
                roosterjs_editor_dom_2.unwrap(node);
            }
        }
    });
}
//# sourceMappingURL=experimentSetIndentation.js.map